export default __webpack_public_path__ + "static/media/learning-memory-and-decision-lab.f7e6c061.png";